import type { ApiResponse } from '../../api';

/** One page from a list endpoint, with the total from its `pagination-total` header. */
export interface RosterApiPage<T> {
    items: T[];
    total: number;
}

/**
 * Items plus the total from `pagination-total`. A missing total is an error, not zero (NS-3).
 * Shared by the support and provider-app clients — both list endpoints report totals this way.
 */
export async function rosterApiPage<T>(raw: ApiResponse<T[]>): Promise<RosterApiPage<T>> {
    const items = await raw.value();
    const header = raw.raw.headers.get('pagination-total');
    const total = header === null ? NaN : Number(header);
    if (!Number.isFinite(total)) {
        throw new Error('The response carried no total.');
    }
    return { items, total };
}
